import React from 'react';
import {
  LayoutCardList,
  LayoutCardSize,
  LayoutCardType,
  LayoutCardListHeading,
} from 'src/modules/layout';
import { ProductCategoryEntity } from 'src/modules/products';
import { withBreakpoints } from 'react-breakpoints';
// import { breakpoints } from 'src/utils/breakpoints';
import { useLocale } from 'src/modules/locale';
import { getImageBreakpointUrl } from 'src/utils/image';

interface ProductsCategoriesOverviewProps {
  headingTitle?: string;
  headingMore?: boolean;
  bordered?: boolean;
  relatedOverview?: boolean;
  productCategories: ProductCategoryEntity[];
}

const ProductsCategoriesOverview: React.FunctionComponent<ProductsCategoriesOverviewProps> = (
  props
) => {
  const { getLocalizedObject } = useLocale();
  const {
    headingTitle = 'page/products/details/section_products_subheading',
    headingMore = true,
    bordered = true,
    productCategories,
    relatedOverview = false,
    currentBreakpoint,
  } = getLocalizedObject(props);

  return productCategories && productCategories.length ? (
    <div>
      {relatedOverview && (
        <LayoutCardListHeading
          title={headingTitle}
          link="/products"
          seeAll={headingMore ? 'page/products/details/section_products_more' : null}
        />
      )}

      <LayoutCardList
        size={LayoutCardSize.Small}
        type={LayoutCardType.Overview}
        bordered={bordered}
        items={productCategories.map((productCategory) => ({
          id: productCategory.id,
          image: getImageBreakpointUrl(currentBreakpoint, productCategory.image),
          slug: productCategory.slug,
          href: '/products/[category]',
          as: '/products/' + productCategory.slug,
          dynamicRoute: false,
          title: productCategory.name,
          count: productCategory.count,
        }))}
      />
    </div>
  ) : null;
};

export default withBreakpoints(ProductsCategoriesOverview);
